import React, { useCallback, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import FinancialSectionDataEntryModal from '@/modules/financials/components/FinancialSectionDataEntryModal';

const FinancialSectionDataEntryButton = ({
  data,
  refreshTask,
  isEmpty = false,
  addText,
  editText,
}) => {
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Button
        color="success"
        size="medium"
        variant={isEmpty ? 'contained' : 'text'}
        startIcon={isEmpty ? <AddIcon /> : <EditIcon />}
        onClick={openModal}
      >
        {isEmpty ? addText : editText}
      </Button>
      <FinancialSectionDataEntryModal
        data={open ? data : null}
        onClose={closeModal}
        refreshTask={refreshTask}
      />
    </>
  );
};

export default FinancialSectionDataEntryButton;
